module.exports = __webpack_public_path__ + "videos/12.4a300cf.mp4";